import * as BsIcons from "react-icons/bs";

export const BlueshiftIcon = {
    CloudInit() {
        return (<div style={{ display: 'inline-block', position: 'relative' }} >
            <i style={{ fontSize: '8px', position: 'absolute', left: '0', bottom: '2px', width: '100%', textAlign:'center' }}>
                <BsIcons.BsTools/>
            </i>
            <BsIcons.BsCloud/>

        </div>);
    },
    FlavorIcon() {
        return (<div style={{display: "block", position: "relative", fontSize: "70px"}}>
            <i className="mx-3"><BsIcons.BsDisplay/><i style={{fontSize: "58px"}}><BsIcons.BsPc/></i></i>
        </div>)
    },
    Snapshot() {
        return (<div style={{display: "block", position: "relative", fontSize: "70px"}}>
                <BsIcons.BsFile/>
                <i style={{fontSize: "35px", position: "absolute", left: 0, bottom: "25px", width: "100%", textAlign: "center"}}><BsIcons.BsClockHistory/></i>
            </div>)
    }
}